import { createStore } from 'vuex'

// modules
import allAccounts from './modules/all-accounts.js'
import circle from './modules/circle.js'
import circleEdit from './modules/circleEdit.js'
import circles from './modules/circles.js'
import core from './modules/core.js'
import entry from './modules/entry.js'
import entryFilter from './modules/entry-filter.js'
import error from './modules/error.js'
import favorite from './modules/favorite.js'
import follows from './modules/follows.js'
import keywordSearch from './modules/keyword-search.js'
import hashtag from './modules/hashtag.js'
import notification from './modules/notification.js'
import myspace from './modules/myspace.js'
import square from './modules/square.js'

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions:{},
  modules: {
    allAccounts,
    circle,
    circleEdit,
    circles,
    core,
    entry,
    entryFilter,
    error,
    favorite,
    follows,
    hashtag,
    keywordSearch,
    notification,
    myspace,
    square,
  }
})